import moment from "moment";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

function PlanMealPlansCard({ mealPlans, dayKey }) {
  const { t } = useTranslation("athlete-portal");
  if (!mealPlans || mealPlans.length === 0 || !dayKey) return null;
  const dayUtc = parseInt(moment(dayKey, "YYYY-MM-DD").format("YYYYMMDD"), 10);
  const active = mealPlans.filter(
    (mp) => mp.utcStartDate <= dayUtc && mp.utcEndDate >= dayUtc
  );
  if (active.length === 0) return null;

  return (
    <>
      {active.map((mp) => (
        <div key={mp._id} className="plan-card plan-card--meal-plans">
          <div className="plan-card__header">
            <SvgIcon
              src="/img/new-icons/restaurant.svg"
              useCurrentColor={true}
            />
            {mp.title || t("calendar.planView.mealPlan")}
          </div>
        </div>
      ))}
    </>
  );
}

export default PlanMealPlansCard;
